import { render } from "./TypeUpdate.vue?vue&type=template&id=dc4954b6"
import script from "./TypeUpdate.vue?vue&type=script&lang=js"
export * from "./TypeUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__